{
  "versions": [
    {
      "version": "6.1.27",
      "date": "2026-10-19",
      "items": [
        {
          "text": "Stay safe: we now let you know when you're chatting with a brand-new account.",
          "platform": "all",
          "screenSize": "all"
        },
        {
          "text": "Bug fixes and performance improvements.",
          "platform": "all",
          "screenSize": "all",
          "dedupeKey": "bug-fixes-performance"
        }
      ]
    },
    {
      "version": "6.1.25",
      "date": "2026-10-10",
      "items": [
        {
          "text": "#Hashtags are back! Tap one to find more posts on the same topic.",
          "platform": "all",
          "screenSize": "all"
        },
        {
          "text": "Bug fixes and performance improvements.",
          "platform": "all",
          "screenSize": "all",
          "dedupeKey": "bug-fixes-performance"
        }
      ]
    },
    {
      "version": "6.1.22",
      "date": "2026-09-28",
      "items": [
        {
          "text": "Uploading photos is quicker and uses less data.",
          "platform": "all",
          "screenSize": "all"
        }
      ]
    },
    {
      "version": "6.1.19",
      "date": "2026-09-14",
      "items": [
        {
          "text": "Messages has a Deleted folder again. Restore any conversation you removed in the last 90 days.",
          "platform": "all",
          "screenSize": "all"
        }
      ]
    },
    {
      "version": "6.1.14",
      "date": "2026-07-12",
      "items": [
        {
          "text": "See when someone was last online, right on their card in People lists.",
          "platform": "all",
          "screenSize": "all"
        },
        {
          "text": "Bug fixes and performance improvements.",
          "platform": "all",
          "screenSize": "all",
          "dedupeKey": "bug-fixes-performance"
        }
      ]
    },
    {
      "version": "6.1.11",
      "date": "2026-07-06",
      "items": [
        {
          "text": "Your recent profile visitors now appear on the home page, right next to Online Now.",
          "platform": "all",
          "screenSize": "large"
        },
        {
          "text": "Performance boost: we tuned the app's engine room so screens load faster and everything feels more responsive.",
          "platform": "android",
          "screenSize": "all"
        },
        {
          "text": "Bug fixes and performance improvements.",
          "platform": "all",
          "screenSize": "all",
          "dedupeKey": "bug-fixes-performance"
        }
      ]
    },
    {
      "version": "6.1.6",
      "date": "2026-06-13",
      "items": [
        {
          "text": "Tablets now have back buttons and keep your spot in lists when you go back.",
          "platform": "native",
          "screenSize": "large"
        },
        {
          "text": "Chats now tell you when you're offline, and catch up on new messages as soon as you reconnect.",
          "platform": "all",
          "screenSize": "all"
        },
        {
          "text": "Swipe between photos in a chat — no need to close one to see the next.",
          "platform": "all",
          "screenSize": "all"
        },
        {
          "text": "Bug fixes and performance improvements.",
          "platform": "all",
          "screenSize": "all",
          "dedupeKey": "bug-fixes-performance"
        }
      ]
    },
    {
      "version": "6.1.3",
      "date": "2026-06-04",
      "items": [
        {
          "text": "🎉 Send and view GIFs in messages and newsfeed comments.",
          "platform": "all",
          "screenSize": "all"
        },
        {
          "text": "Bug fixes and performance improvements.",
          "platform": "all",
          "screenSize": "all",
          "dedupeKey": "bug-fixes-performance"
        }
      ]
    },
    {
      "version": "6.1.1",
      "date": "2026-05-30",
      "items": [
        {
          "text": "Fixed an issue where the upload photo menu in chats wouldn't respond on some devices.",
          "platform": "android",
          "screenSize": "all"
        },
        {
          "text": "Bug fixes and performance improvements.",
          "platform": "all",
          "screenSize": "all",
          "dedupeKey": "bug-fixes-performance"
        }
      ]
    },
    {
      "version": "6.1.0",
      "date": "2026-05-22",
      "items": [
        {
          "text": "Smoother posting, commenting, and messaging — keyboard stays put, send feels snappier, and new comments scroll into view.",
          "platform": "native",
          "screenSize": "all"
        },
        {
          "text": "Bug fixes and performance improvements.",
          "platform": "all",
          "screenSize": "all",
          "dedupeKey": "bug-fixes-performance"
        }
      ]
    },
    {
      "version": "6.0.190",
      "date": "2026-05-14",
      "items": [
        {
          "text": "Shared links (profiles, events, photos, etc.) used in bios, posts and messages now open right inside the app instead of opening in a browser.",
          "platform": "native",
          "screenSize": "all"
        },
        {
          "text": "Tapping a shared link from outside the app now takes you directly to the right screen in the app.",
          "platform": "native",
          "screenSize": "all"
        },
        {
          "text": "Bug fixes and performance improvements.",
          "platform": "all",
          "screenSize": "all",
          "dedupeKey": "bug-fixes-performance"
        }
      ]
    },
    {
      "version": "6.0.186",
      "date": "2026-05-11",
      "items": [
        {
          "text": "Bug fixes and performance improvements.",
          "platform": "all",
          "screenSize": "all",
          "dedupeKey": "bug-fixes-performance"
        }
      ]
    },
    {
      "version": "6.0.180",
      "date": "2026-05-06",
      "items": [
        {
          "text": "Navigating between bottom tabs and opening screens is now faster on Android.",
          "platform": "android",
          "screenSize": "all"
        },
        {
          "text": "Quality of life improvements in various app surfaces, including member profile and sliding panels.",
          "platform": "all",
          "screenSize": "small"
        },
        {
          "text": "Bug fixes and performance improvements.",
          "platform": "all",
          "screenSize": "all",
          "dedupeKey": "bug-fixes-performance"
        }
      ]
    },
    {
      "version": "6.0.176",
      "date": "2026-05-01",
      "items": [
        {
          "text": "New compact layout option for member lists: see more people on one screen.",
          "platform": "all",
          "screenSize": "small"
        },
        {
          "text": "Bug fixes and performance improvements.",
          "platform": "all",
          "screenSize": "all",
          "dedupeKey": "bug-fixes-performance"
        }
      ]
    },
    {
      "version": "6.0.173",
      "date": "2026-04-27",
      "items": [
        {
          "text": "This What's New sheet to announce new features and updates, also available anytime from Settings.",
          "platform": "all",
          "screenSize": "all"
        },
        {
          "text": "Manage your notifications better with new dismiss and Clear all options.",
          "platform": "all",
          "screenSize": "all"
        },
        {
          "text": "Spot new notifications right from your browser tab.",
          "platform": "web",
          "screenSize": "large"
        },
        {
          "text": "Bug fixes and performance improvements.",
          "platform": "all",
          "screenSize": "all",
          "dedupeKey": "bug-fixes-performance"
        }
      ]
    },
    {
      "version": "6.0.165",
      "date": "2026-04-22",
      "items": [
        {
          "text": "Improved web navigation, including more reliable back button behavior.",
          "platform": "web",
          "screenSize": "all"
        },
        {
          "text": "Quickly switch lists from the bottom tabs: press and hold a tab, then slide up.",
          "platform": "native",
          "screenSize": "small"
        },
        {
          "text": "Bug fixes and performance improvements.",
          "platform": "all",
          "screenSize": "all",
          "dedupeKey": "bug-fixes-performance"
        }
      ]
    },
    {
      "version": "6.0.159",
      "date": "2026-04-20",
      "items": [
        {
          "text": "Unsubscribe from someone's private photos directly from their profile.",
          "platform": "all",
          "screenSize": "all"
        },
        {
          "text": "Add more to your profile with longer profile bios.",
          "platform": "all",
          "screenSize": "all"
        }
      ]
    },
    {
      "version": "6.0.158",
      "date": "2026-04-20",
      "items": [
        {
          "text": "Browse photos faster, with quicker opens and smoother swiping.",
          "platform": "all",
          "screenSize": "all"
        }
      ]
    },
    {
      "version": "6.0.150",
      "date": "2026-04-18",
      "items": [
        {
          "text": "The home page now shows who's online and upcoming community events.",
          "platform": "all",
          "screenSize": "large"
        }
      ]
    },
    {
      "version": "6.0.147",
      "date": "2026-04-17",
      "items": [
        {
          "text": "Choose chimes for new messages and notifications, or turn them off.",
          "platform": "web",
          "screenSize": "large"
        }
      ]
    },
    {
      "version": "6.0.146",
      "date": "2026-04-16",
      "items": [
        {
          "text": "Catch up faster with recent comments shown right in your feed.",
          "platform": "all",
          "screenSize": "all"
        }
      ]
    },
    {
      "version": "6.0.139",
      "date": "2026-04-11",
      "items": [
        {
          "text": "Personalize the app with alternate home screen icons.",
          "platform": "ios",
          "screenSize": "all"
        }
      ]
    },
    {
      "version": "6.0.133",
      "date": "2026-04-09",
      "items": [
        {
          "text": "Fresh new look — Grokio Communities is now one unified app across web, iOS, and Android.",
          "platform": "all",
          "screenSize": "all"
        }
      ]
    }
  ]
}
